import { Container, Row, Col } from "react-bootstrap";

import Head from "../components/formation/head.jsx";
import Programme from "../components/formation/programme.jsx";
import ChooseUs from "../components/formation/choose.jsx";
import Footer from "../components/general/footer.jsx";

const Formations = () => {
  return (
    <section className="formations">
      <Head />
      <Programme />
      <ChooseUs />
      <Footer />
    </section>
  );
};

export default Formations;
